import {inject, InjectionToken, Pipe, PipeTransform} from '@angular/core';
import {ImcLevel} from '../constants/imc.level';

// Accepted types
export type SdLevel = 'SD3-' | 'SD2-' | 'SD1-' | 'SD0' | 'SD1' | 'SD2' | 'SD3';

// Rótulos do IMC-para-idade. Casam EXATAMENTE com o mapa do componente/serviço
// de IMC (o mesmo texto vai para o Firebase em visit.imcLevel). Déficit de IMC
// é tratado no projeto como desnutrição AGUDA, não crónica.
export const SD_LEVEL_LABELS = new InjectionToken<
    Partial<Record<SdLevel, string>>
>('SD_LEVEL_LABELS', {
    factory: () => ({
        'SD3-': ImcLevel.SEVERE_ACUTE_MALNUTRITION,  // 'Desnutrición Aguda severa'
        'SD2-': ImcLevel.MODERATE_MALNUTRITION,      // 'Desnutrición Aguda modera'
        'SD1-': ImcLevel.NORMAL,                     // 'Normal'
        'SD0': ImcLevel.NORMAL_1,                    // 'Normal'
        'SD1': ImcLevel.RISK_OF_OVERWEIGHT,          // 'Riesgo de Sobrepeso'
        'SD2': ImcLevel.OVERWEIGHT,                  // 'Sobrepeso'
        'SD3': ImcLevel.OBESITY,                     // 'Obesidad'
    }),
});

@Pipe({
    name: 'imcMalnutritionLevel',
    pure: true,
})
export class IMCMalnutritionLevelPipe implements PipeTransform {
    private labels = inject(SD_LEVEL_LABELS);

    /**
     * @param value  Nível SD (ex.: 'SD2-')
     * @param fallback Texto opcional caso não exista rótulo (default: próprio value)
     */
    transform(value: SdLevel | string | null | undefined, fallback?: string): string {
        if (!value) {
            return fallback ?? 'No medido';
        }
        const v = value as SdLevel;
        return this.labels[v] ?? fallback ?? String(value);
    }
}
